export default __webpack_public_path__ + "static/media/jp.e2f58c0d.svg";